import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../contexts/AuthContext";
import LoadingScreen from "../components/LoadingScreen";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = /session_id=([^&]+)/.exec(hash);
    if (!m) { navigate("/login"); return; }
    const sessionId = m[1];
    const startedAt = Date.now();

    (async () => {
      try {
        const r = await api.post("/auth/google/session", { session_id: sessionId });
        login(r.data.token, r.data.user);
        // Clean the hash from the URL so it doesn't re-trigger this component.
        window.history.replaceState({}, "", window.location.pathname);
        toast.success("Welcome to Dnya");
        // Enforce a minimum 1s display so the LoadingScreen doesn't flash.
        const dwell = Math.max(0, 1000 - (Date.now() - startedAt));
        const target = r.data.user?.terms_accepted ? "/dashboard" : "/terms";
        setTimeout(() => {
          // Hard-navigate so React tree fully re-boots with the fresh JWT —
          // avoids any race between setState and Protected-route guards.
          window.location.href = target;
        }, dwell);
      } catch (e) {
        toast.error("Google sign-in failed");
        navigate("/login");
      }
    })();
  }, [login, navigate]);

  return <LoadingScreen title="Assalamu Alaikum" subtitle="Preparing your space, Insha'Allah" />;
}
